import { IPickerTab, PickerItem } from "./Picker.types";

export const ungrouped: IPickerTab<"never"> = {
    id: "never",
    label: "Ungrouped",
};

function pickTab<TTab extends string, TGroup extends string>(
    tabs: IPickerTab<TTab>[],
    item: PickerItem<TTab, TGroup>,
): IPickerTab<TTab | "never"> {
    if (!item.tab) {
        return ungrouped;
    }
    return tabs.find(it => it.id === item.tab) ?? ungrouped;
}

export function searchItemsFor<
    TTab extends string = string,
    TGroup extends string = string,
>(items: PickerItem<TTab, TGroup>[], tabs: IPickerTab<TTab>[], query: string) {
    type GroupTuple = [
        Map<IPickerTab<TTab | "never">, Set<PickerItem<TTab, TGroup>>>,
        number,
    ];

    return items
        .filter(it =>
            "label" in it
                ? it.label
                      .toLocaleLowerCase()
                      .includes(query.toLocaleLowerCase())
                : false,
        )
        .reduce<GroupTuple>(
            ([groupings, count], item) => {
                const key = pickTab(tabs, item);
                const groupSet = groupings.get(key) ?? new Set();
                groupSet.add(item);
                groupings.set(key, groupSet);
                return [groupings, count + 1];
            },
            [new Map(), 0],
        );
}

export function filterItemsByTabs<
    TTab extends string = string,
    TGroup extends string = string,
>(
    selectedTab: string | null | undefined,
    items: PickerItem<TTab, TGroup>[],
): [Set<PickerItem<TTab, TGroup>>, number] {
    if (!selectedTab) {
        return [new Set(items), items.length];
    }

    const itemsInTab = items.filter(it => it.tab === selectedTab);
    return [new Set(itemsInTab), itemsInTab.length];
}
